export enum UserRemindEnum {
  Voucher = 'account.voucher'
}
